import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
});

const apiSuperAdmin = {
    getAllUsers: (payload) =>
        axiosInstance.post("/user/get-all", payload),

    getAllOnlineUsers: (payload) =>
        axiosInstance.post("/user/get-all-online", payload),
};

export default apiSuperAdmin;
